export const OutsideClickDirective = [function () {
    function link(scope, element, attr) {
        let clickListener = function (evt) {
            let targetElement = evt.target; // clicked element
            do {
                if (targetElement == element[0]) {
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);
            scope.clickOutsideCallback && scope.clickOutsideCallback(true);
        };

        document.addEventListener("click", clickListener);

        element.on('$destroy', function () {
            document.removeEventListener('click', clickListener);
        })
    }

    return {
        restrict: 'A',
        scope: {
            clickOutsideCallback: '<'
        },
        link: link
    }
}];